
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Appendiceal_tumor",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Appendiceal_tumor.vue